export default 'mobile';
